<template>
	<div>
    <section class="section section-top-padding">

      <div class="container" style="padding-top:50px;">
       <div class="columns is-multiline">

       	<div class="column is-12">
       		<h1 class="title">Übersicht</h1>
       	</div>

        <div class="column is-12">

            <table class="table is-bordered is-hoverable is-striped is-narrow is-fullwidth" v-if="overview.length">
              <thead>
              <tr>
                  <th></th>
                  <th colspan="2">Sichtbarkeit</th>
                  <th colspan="2">Überschrift</th>
                  <th></th>
                </tr>
                <tr>
                  <th>Template</th>
                  <th>DE</th>
                  <th>EN</th>
                  <th>DE</th>
                  <th>EN</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i, index) in overview" :key="index">
                  <td><span v-if="i.type==1">Projekt</span><span v-else-if="i.type==2">Thema</span><span v-else-if="i.type==3">Sections</span><span v-else-if="i.type==4">Content</span><span v-else-if="i.type==5">Team</span></td>
                  <td>
                    <a @click="activation({ id: i.id, lang: 'de' })" v-if="i.type==1">
                      <span class="icon"><i class="fa" :class="[i.de_active ? 'fa-check-circle-o' : 'fa-circle-o']"></i></span>
                    </a>
                    <span class="icon" style="color: #888888;" v-else><i class="fa fa-check-circle-o"></i></span>
                  </td>
                  <td><a @click="activation({ id: i.id, lang: 'en' })" v-if="i.en_headline!==null"><span class="icon"><i class="fa" :class="[i.en_active ? 'fa-check-circle-o' : 'fa-circle-o']"></i></span></a><span class="icon" v-else><i class="fa fa-close"></i></span></td>
                  <td><router-link :to="'/cms/edit/' + i.id + '?lang=de'">{{ i.headline }}</router-link></td>
                  <td><router-link :to="'/cms/edit/' + i.id + '?lang=en&new=true'" v-if="i.en_headline===null"><span class="icon"><i class="fa fa-flag"></i></span>Übersetzen</router-link><router-link :to="'/cms/edit/' + i.id + '?lang=en'" v-else>{{ i.en_headline }}</router-link></td>
                  <td><a @click="deleteContent(i.id)" v-if="i.type==1" class="button is-small is-danger"><span class="icon"><i class="fa fa-trash-o"></i></span></a><span class="button is-small is-danger" disabled v-else><span class="icon"<i class="fa fa-trash-o"></i></span></span></td>
                </tr>
              </tbody>
            </table>

            <span v-else>Keine Seiten vorhanden<br><router-link to="/cms/create" tag="a">Neues Projekt anlegen</router-link></span>

        </div>
    </div>
</div>
</section>
</div>
	
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      overview: []
    }
  },
  metaInfo: {
    meta: [
      { name: 'robots', content: 'NOINDEX, NOFOLLOW' }
    ]
  },
  methods: {
    activation (v) {
      const vm = this
      axios.put('/content/activation/' + v.id, {
        lang: v.lang
      })
        .then(function (response) {
          vm.getOverview()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    deleteContent (v) {
      if (confirm('Sind Sie sich sicher?') === true) {
        const vm = this
        axios.delete('/content/' + v)
          .then(function (response) {
            vm.getOverview()
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    getOverview () {
      const vm = this
      axios.get('/content/overview')
        .then(function (res) {
          vm.overview = res.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.getOverview()
  }
}
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/components/cms/List.vue